// Floating leaves for the dino/jungle theme.
export function Leaves() {
  return (
    <div className="theme-decoration theme-decoration-leaves" aria-hidden="true">
      <span className="leaf leaf-1">🌿</span>
      <span className="leaf leaf-2">🍃</span>
      <span className="leaf leaf-3">🌿</span>
      <span className="leaf leaf-4">🍃</span>
    </div>
  );
}
